import React, { useEffect, useRef } from "react";
import {
  consentMappingKeys,
  FormBuilderElementsMappingService
} from "../../../../services/builder/form-builder.elements-mapping.service";
export const loyaltyTermsAndConditionsLabelKey = "FORM.INPUT INPUT-LOYALTY-SIGN-UP.TERMS-AND-CONDITIONS_LABEL";
export const loyaltyTermsAndConditionsURLKey = "FORM.INPUT INPUT-LOYALTY-SIGN-UP.TERMS-AND-CONDITIONS_URL";
export const loyaltyPrivacyPolicyLabelKey = "FORM.INPUT INPUT-LOYALTY-SIGN-UP.PRIVACY-POLICY-LABEL";
export const loyaltyPrivacyPolicyURLKey = "FORM.INPUT INPUT-LOYALTY-SIGN-UP.PRIVACY-POLICY-URL";
const FormBuilderFormInterfaceLoyaltySignUp = ({ item, formId, analyticForm, t }) => {
  if (!item) return null;
  const inputRef = useRef();
  const { input: checkbox, label } = FormBuilderElementsMappingService.getSingleElementHTMLTags(item);
  const onFocus = () => {
    analyticForm == null ? void 0 : analyticForm.trackInputFocused(checkbox.name);
  };
  const onBlur = () => analyticForm == null ? void 0 : analyticForm.trackInputBlurred(checkbox.name);
  useEffect(() => {
    const formDiv = document.querySelector(`[form-id="${formId}"] div`);
    if (formDiv == null ? void 0 : formDiv.shadowRoot) {
      const dataMapping = checkbox == null ? void 0 : checkbox["data-mapping"];
      const dataMappingObj = dataMapping ? JSON.parse(dataMapping) : {};
      const relatedElement = formDiv.shadowRoot.querySelector(
        `[name="${dataMappingObj == null ? void 0 : dataMappingObj[consentMappingKeys.MEMBER_ID]}"]`
      );
      inputRef.current.disabled = true;
      const validateInput = () => {
        const isEmailEmpty = relatedElement.value === "" || relatedElement.value === void 0;
        inputRef.current.disabled = isEmailEmpty;
        if (inputRef.current.checked && isEmailEmpty) {
          inputRef.current.checked = false;
        }
      };
      if (relatedElement) {
        relatedElement.addEventListener("change", validateInput);
      }
      return () => relatedElement.removeEventListener("change", validateInput);
    }
  }, [formId, checkbox]);
  const termsAndConditionsLink = `<a href="${t(loyaltyTermsAndConditionsURLKey)}" target="_blank">${t(
    loyaltyTermsAndConditionsLabelKey
  )}</a>`;
  const privacyPolicyLink = `<a href="${t(loyaltyPrivacyPolicyURLKey)}" target="_blank">${t(
    loyaltyPrivacyPolicyLabelKey
  )}</a>`;
  const textHtml = t(label.nodeValue, {
    terms_link: termsAndConditionsLink,
    privacy_policy_link: privacyPolicyLink
  });
  return /* @__PURE__ */ React.createElement("div", { className: `${item.class}` }, /* @__PURE__ */ React.createElement(
    "input",
    {
      ref: inputRef,
      type: checkbox == null ? void 0 : checkbox.type,
      name: checkbox == null ? void 0 : checkbox.name,
      onFocus,
      onBlur,
      id: checkbox == null ? void 0 : checkbox.id,
      required: checkbox == null ? void 0 : checkbox.required,
      value: checkbox.value ? checkbox.value : ""
    }
  ), /* @__PURE__ */ React.createElement("label", { htmlFor: label.for, dangerouslySetInnerHTML: { __html: textHtml } }));
};
FormBuilderFormInterfaceLoyaltySignUp.displayName = "FormBuilderFormInterfaceLoyaltySignUp";
export default FormBuilderFormInterfaceLoyaltySignUp;
